export default __webpack_public_path__ + "static/media/somethingWentWrong.582ffd26.svg";